
import { defineComponent, computed, onMounted, ref } from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import ServiceList from "@/components/home/ServiceList.vue";
import { PAGE_ID } from "@/const/log-const";
import { dummyServiceList } from "@/utils/home-util";
import store from "@/store";
import {
  ServiceImageData,
  ServiceData,
  InformationServices
} from "@/types/home";
import CommonUtil from "@/utils/common-utils";
import { BeaconLogInfo } from "@/types/common";

export default defineComponent({
  name: "ServiceListPage",
  components: { ServiceList },
  setup() {
    NativeClient.setTitle(new TitleInfo(false, "サービス一覧"));
    CommonUtil.scroll({ top: 0, left: 0 });
    /**
     * サービス一覧を取得する
     */
    const getServices = async () => {
      store.dispatch("common/startLoading");
      await store.dispatch("home/getInformationServices");
      store.dispatch("common/stopLoading");
    };

    const execute = async () => {
      getServices();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(() => {
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.HOME_SERVICE, null, new Array<string>());
      NativeClient.sendViewedLog(beaconLogInfo);
      execute();
    });

    const getServiceData = (sevices: InformationServices) => {
      const serviceList = Array<ServiceData>();
      serviceList.length = 0;
      NativeClient.sendDebugLog(
        "ServiceListPage services computed result=" + JSON.stringify(sevices)
      );
      if (sevices != null && sevices.services != null) {
        if (sevices.services.length >= 1) {
          let i = 0;
          sevices.services.forEach(e => {
            const serviceImageData = new ServiceImageData(null, null);
            if (e.image != null) {
              serviceImageData.top = e.image.top;
              serviceImageData.thumb = e.image.thumb;
            }
            const serviceData = new ServiceData(
              i,
              e.title,
              e.description,
              serviceImageData,
              e.contentsUrl,
              e.externalContentsFlg
            );
            serviceList.push(serviceData);
            i++;
          });
        } else {
          dummyServiceList.forEach(e => {
            serviceList.push(e);
          });
        }
      }
      NativeClient.sendDebugLog(
        "ServiceListPage services computed serviceList=" +
          JSON.stringify(serviceList)
      );
      return serviceList;
    };

    const services = computed(() => {
      const result: InformationServices =
        store.getters["home/getInformationServices"];
      return getServiceData(result);
    });

    /**
     * 選択されたurlをNativeに通知する
     */
    const selectService = (
      id: number,
      title: string,
      contentsUrl: string | null,
      externalContentsFlg: boolean
    ) => {
      let url = contentsUrl;
      if (url == null) {
        return;
      }
      // 外部ブラウザ起動
      let extenalUrl = null;
      if (externalContentsFlg) {
        extenalUrl = contentsUrl;
        url += "?window=browser";
      } else {
        url += "?window=webview";
      }
      NativeClient.sendDebugLog("selectService url=" + url);
      const serviceId = id + 1;
      const objectId = "btn_" + serviceId + "_B-26_ServiceIcon";
      const viewedItem = Array<string>();
      if (extenalUrl != null) {
        viewedItem.push(extenalUrl);
      }
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.HOME_SERVICE, objectId, viewedItem);
      NativeClient.sendClickedActionLog(beaconLogInfo);
      location.href = url;
    };
    return {
      selectService,
      services
    };
  }
});
